import { ofType,ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';


/**
 * This Fuction will intiate screenpop via get method to
 *  backend api and returns status
 * @param context contains the settings etc..
 */

export const enum Types {
    NICECLICKTOTRANSFER = 'NICE-CLICK-TO-TRANSFER ',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}


const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const niceClickToTransfer = (context: any) => (
    (action$: ActionsObservable<any>,state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,
            log,
            alertnotification,
            agentId,teamName,
            settings:
            {
                epicendpoints: { niceclicktocall,apitoken }, servers,
                compatible : {contact_center_type },
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.NICECLICKTOTRANSFER),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {

                    if (datares) {
                        let headers = new Headers();
                        
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "agentId":datares.agentId,
                            "phoneNumber": datares.phoneNumber,
                            "contactId": datares.contactId,
                        }
                        const response = serverone.post({
                            path: niceclicktocall,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,clicktocall-epic",
                                    "fetch-clicktocall-epic", {
                                        responseresult
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "nice click to call",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                        })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                              //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any=[]                         
                            // let disp: Disposition = { value: "" };
                            // if (contact_center_type && contact_center_type === "five9") {
                            //     let skillName = sessionStorage.getItem("skillName");
                            //     disp.meta01 = skillName;
                            // }
                            // else {
                            //     disp.meta01 = teamName;
                            // }
                            // disp.meta00 = agentId;
                            // disp.meta02 = "";
                            // disp.meta03 = "";
                            // actions.push(pushToDisposition(disp));

                            if (response?.output?.success == true) {
                                let disp: Disposition = { value: "2027" }
                                if (contact_center_type && contact_center_type === 'inContact') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.key;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                          else if (response?.errors && response?.errors?.length > 0) {
                                let disp: Disposition = { value: "2028" }
                                if (contact_center_type && contact_center_type === 'inContact') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = teamName;
                                disp.meta02 = dataresponse?.key;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                                /*changes for errors will pushed to bell icon*/
                                let errorbuild: ErrorObject = {
                                    source: "Screenpop",
                                    type: "error",
                                    status: response?.status,
                                    erroritems: response?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                actions.push(addAction(errorbuild))
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);